export default __webpack_public_path__ + "static/media/image.67a31ac4.svg";